var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/address-form/default-address.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n<div class=\"c-form__field\">\n\n    <ul class=\"c-form-adjacent\">\n\n        <li class=\"c-form-adjacent__li\">\n\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup(((lineno = 8, colno = 23, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["relationships"]))),"profile")),"profile")),"defaultShippingAddressId") == runtime.memberLookup(((lineno = 8, colno = 96, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"id")) {
output += "\n\n            <input type=\"checkbox\" name=\"address-default\" class=\"js-account-set-default-address c-form-adjacent__checkbox\" id=\"address-default\" checked data-qa-set-as-default-address=\"checked\" aria-describedby=\"address-default_error\"/>\n\n        ";
;
}
else {
output += "\n\n            <input type=\"checkbox\" name=\"address-default\" class=\"js-account-set-default-address c-form-adjacent__checkbox\" id=\"address-default\" data-qa-set-as-default-address=\"unchecked\" aria-describedby=\"address-default_error\"/>\n\n        ";
;
}
output += "\n\n            <label for=\"address-default\" class=\"c-form-adjacent__label\" id=\"address-default_error\" data-qa-make-default-address-text>\n\n                ";
output += runtime.suppressValue((lineno = 20, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-globalFormField-makeDefaultAddress",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n            </label>\n\n        </li>\n\n    </ul>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/address-form/default-address.j2"] , dependencies)